<template>
  <!--   This component just builds the appropriate html / css framework
  for a lazy scroller on the y axis. It does not provide any logic
  and is just a rendering template
 -->
  <div
    ref="main"
    :class="scroll_container_classes"
    @[maybescroll]="scroll_handler"
  >
    <component
      :is="render.container"
      ref="dyncomp"
      :class="container_classes"
      :style="container_style"
    >
      <template v-if="render.initialized">
        <template
          v-for="nby in _.range(render.component_start, render.component_stop)"
        >
          <slot name="default" :nby="nby" :initialized="true"></slot>
        </template>
      </template>
      <template v-else>
        <slot name="default" :nby="0" :initialized="false"></slot>
      </template>
    </component>
  </div>
</template>

<script>
import _ from 'lodash'

// *****************************************************************************

export default {
  name: 'LazyListY',
  props: ['render'],
  computed: {
    _() {
      return _
    },
    maybescroll() {
      const res = this.render.scroll ? '&scroll' : null
      return res
    },
    scroll_container_classes() {
      let scroll_container_classes = ['synaplus-cosmo-scroll-container']
      if (this.render.scroll) {
        scroll_container_classes.push('synaplus-cosmo-add-scrollbar-y')
      } else {
        scroll_container_classes.push('synaplus-cosmo-no-scrollbar-y')
      }
      return scroll_container_classes
    },
    container_classes() {
      let res = ['synaplus-cosmo-scroll-containee']
      res = res.concat(this.render.container_class)
      return res
    },
    container_style() {
      return {
        'padding-top': `${this.render.padding_low}px`,
        'padding-bottom': `${this.render.padding_high}px`,
        height: `${this.render.really_rendered_size}px`,
      }
    },
  },
  mounted() {
    if (!this.render.initialized) {
      this.$emit('initialize', this.$refs.main, this.$refs.dyncomp.firstChild)
    }
  },
  updated() {
    this.$emit('updated')
  },
  methods: {
    scroll_handler(evt) {
      this.$emit('scrolly', evt)
    },
  },
}
</script>
